const isiOSDevice = (): boolean => {
    return Boolean(navigator.userAgent.match(/iPhone|iPad|iPod/i))
}

export { isiOSDevice }